import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
      ratio: 0, //rem-px比例
      uid: null, //用户ID
      token: null, //用户token
      money: 0, //嘟币
      userData: {}, //用户数据--等级、财富等级
      webView: "", //当前界面UI-key
      test: "",
      ioStatus: "", //服务状态
      gameData: {
          state: 1, //当前阶段号 1 游戏关闭 101 押注阶段 102 开奖阶段 103 展示结果阶段
          time: 0, //当前阶段剩余时间
          totalTime: 0, //当前阶段总时间
          myCoin: [], //自己下注嘟币数量
          totalCoin: [], //所有玩家下注嘟币数量
          totalPlayer: [], //下注嘟币人数
          scale: [], //当前赔率
          scaleNext: [], //下一局赔率
          historyRecord: [], //历史记录
          awardList: [], //中奖列表
          propId: [29, 30, 31, 32, 50, 51, 52, 53], //道具ID
          propData: [] //道具数据
      }
  },
  mutations: {

  },
  actions: {

  }
})
